<template lang="pug">
  validation-observer(ref='observer')
    modal-assinatura(
      v-if="modal"
      titulo="Assinar Ofício de Cancelamento de Cláusula Resolutiva"
      texto="Para realizar a assinatura do ofício de cancelamento de cláusula resolutiva é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
      @closeModal="closeModal()"
      @callbackSucesso="callbackModalAssinatura"
    )
    div.container-cadastro
      div#passos
        el-steps(:active='passoAtivo', finish-status='success', simple)
          el-step(title="Informar dados", v-if="isValidacao === false")
          el-step(title="Editar Oficio", v-if="isValidacao === false")
          el-step(title="Confirmar dados" :status= "'naoPrecisaAparecerSucess'")
      div#corpo
        informar-dados(
          v-if="passoAtivo === 1 && isValidacao === false"
          @atualizarListaCartorios="atualizarListaCartorios"
          @atualizarAnexos="atualizarAnexos"
          @changeInteiroTeor="changeInteiroTeor"
          :despacho="despacho"
        )
        validation-provider(v-if="passoAtivo === 2", rules="required", v-slot="{ errors }")
          app-label.input-text-editor(label="Despacho")
          app-editor-texto.input(
            @onTextChange="onTextChange",
            v-model="despacho.tituloDespacho.oficioCcrDTO.textoOficio",
            :class="{'erro' : errors.length}"
            ref="editorTexto"
          )
          span.help.erro {{ errors[0] }}
        confirmar-dados(
          @changeRadio="changeRadio"
          v-if="passoAtivo === 3",
          :oficios="oficios",
          @getBytesPdf="getBytesPdf"
          :idProcesso="processo.id"
          :despacho="despacho"
        )

    app-buttons-cadastro(
      :isPrimeiroPasso="false",
      :isUltimoPasso="ultimoPasso",
      :showButtonSalvar="!ultimoPasso",
      :showButtonDownload="ultimoPasso",
      :showButtonCancelar="false",
      :showButtonProximo="!ultimoPasso",
      @proximo="proximo",
      @salvar="salvar",
      @voltar="voltar",
      @finalizar="assinarOficio",
      @download="download"
    )
</template>

<script>
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import InformarDados from '@/screens/analise/oficio/InformarDados'
import ConfirmarDados from '@/screens/analise/oficio/ConfirmarDados'
import FileHelper from '@/utils/fileHelper'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppLabel from '@/components/AppLabel'
import ModalAssinatura from '@/components/ModalAssinatura'
import { mapGetters, mapActions } from 'vuex'
import AppOpcoesHeaderAnalise from '../components/modal/AppOpcoesHeaderAnalise.vue'

export default {
  components: {
    AppButtonsCadastro,
    InformarDados,
    ConfirmarDados,
    ModalAssinatura,
    AppEditorTexto,
    AppLabel,
    AppOpcoesHeaderAnalise
  },
  mixins: [AppNotificacao],

  props: {
    oficios: {
      required: true,
      type: Array
    },
    processo: {
      required: true,
      type: Object
    },
    despacho: {
      required: true,
      type: Object
    },
    isEdicao: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      guiaAtiva: 'emissao',
      passoAtivo: 1,
      bytes: null,
      modal: false,
      cartoriosSelecionados: [],
      anexos: [],
      inteiroTeor: false,
      acao: '',
      isValidacao: null,
      mensagemNotificacao: {
        RETORNO: 'Processo retornado para o setor anterior!',
        VALIDADO_OFICIO: 'Ofício emitido com sucesso!',
        FINALIZAR: 'Ofício emitido com sucesso!',
        AGUARDANDO_VALIDACAO_OFICIO: 'Processo encaminhado para validação DRF!'
      }
    }
  },
  mounted () {
    this.isValidacao = this.processo.status === 'AGUARDANDO_VALIDACAO_OFICIO'
    this.passoAtivo = this.isValidacao ? 3 : 1
  },
  computed: {
    ultimoPasso () {
      return this.passoAtivo === 3
    },
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    ...mapActions({
      salvarDespacho: 'despachos/save',
      finalizarOficio: 'oficioArrecadacao/finalizar',
      tramitar: 'processo/tramitar',
      deleteById: 'oficioArrecadacao/deleteById',
      salvar: 'despacho/salvar',
      criarNovoOficio: 'despacho/criarNovoOficioCcr',
      getDespachoOficioCcr: 'despacho/getDespachoOficioCcr',
      editarOficio: 'despacho/editarTituloCertidao',
      getOficioCcrByProcessoId: 'despacho/getOficioCcrByProcessoId',
      tramitarComAcao: 'processo/tramitarComAcao',
      finalizarAssinatura: 'processo/finalizaAssinaturaOficio',
      atualizarProcessoAssinatura: 'processo/atualizarProcessoAssinatura',
      processarTemplate: 'despacho/processarTemplate',
      finalizaDespachoOficio: 'despacho/finalizaDespachoOficio'
    }),

    salvar () {
      this.salvarOficioCcr()
    },

    async salvarOficioCcr () {
      if (this.despacho) {
        if (this.isEdicao) {
          try {
            await this.editarOficio(this.despacho)
            this.showNotificacao(
              this.$messages.TIPO_SUCCESS,
              this.$messages.TITULO_SUCCESS,
              'Ofício editado com Sucesso.'
            )
          } catch (error) {
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              'Erro ao editar o ofício, contate o administrador do sistema.'
            )
          }
        } else {
          await this.criarNovoOficio(this.despacho)
            .then((res) => {
              this.despacho.id = res.id
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                'Ofício salvo com Sucesso.'
              )
            })
          this.isEdicao = true
        }
      }
    },

    onTextChange (text) {
      this.despacho.tituloDespacho.oficioCcrDTO.textoOficio = text
    },

    changeRadio (value) {
      this.acao = value.acao
    },

    getBytesPdf (bytes) {
      this.bytes = bytes
    },

    atualizarListaCartorios (cartorios) {
      this.cartoriosSelecionados = cartorios
    },

    async proximo () {
      const valido = await this.validarCampos()

      if (valido) {
        await this.salvarOficioCcr().then(() => {
          if (this.passoAtivo === 1) {
            this.processarTemplate(this.processo.id).then((textoNovo) => {
              this.despacho.tituloDespacho.oficioCcrDTO.textoOficio = textoNovo
              this.passoAtivo = this.passoAtivo + 1
            })
          } else {
            this.passoAtivo = this.passoAtivo + 1
          }
        })
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
      }
    },

    goToListagem () {
      this.$router.push({
        name: 'CAIXA_ENTRADA',
        query: {
          numeroProcesso: this.processo.numeroProcesso,
          idProcesso: this.processo.id
        }
      })
    },

    async finalizar () {
      try {
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.AGUARNDANDO_ENVIO_CERTIDAO_NEGATIVA
        )
        this.goToListagem()
      } catch (error) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          error.message
        )
      }
    },

    async download () {
      const nome = 'oficio_cancelamento_clausula_resolutiva.pdf'
      const oficio = await this.getOficioCcrByProcessoId(this.processo.id)

      FileHelper.saveFile(oficio, nome)
    },

    voltar () {
      if ((this.passoAtivo === 2 || this.passoAtivo === 3) && this.isValidacao === false) {
        this.passoAtivo = this.passoAtivo - 1
      } else {
        this.confirmBox(
          'Você tem certeza que deseja voltar? Todos os dados não salvos serão perdidos.',
          this.$messages.TITULO_WARNING,
          () => {
            if (this.$route.query.botaoEmitirOficio) {
              this.goToOficios()
            } else {
              this.goToListagem()
            }
          },
          () => {},
          'Sim',
          'Não'
        )
      }
    },

    validarCampos () {
      if (this.inteiroTeor && this.anexos.length === 0) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Certidão de Inteiro Teor precisa de ao menos um anexo'
        )
        return false
      }
      return this.$refs.observer.validate()
    },

    closeModal () {
      this.modal = false
    },

    async assinarOficio () {
      if (!await this.$refs.observer.validate()) {
        return
      }
      let despachoFinalizar = {
        idProcesso: this.despacho.processo.id,
        acao: this.acao
      }
      this.finalizaDespachoOficio(despachoFinalizar)
        .then((response) => {
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            this.mensagemNotificacao[this.acao?.split('.')[0]]
          )
          this.goToListagem()
        })
        .catch(() => {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'Erro ao conferir Título.'
          )
        })
    },

    async tramitaComAcao (_acao) {
      await this.tramitarComAcao({
        processoId: this.processo.id,
        acao: _acao
      })
      this.goToListagem()
    },

    async callbackModalAssinatura (senha) {
      this.atualizarProcessoAssinatura([this.processo.id])
      this.finalizarAssinatura({
        idProcessos: [this.processo.id],
        senha: senha,
        statusProcesso: this.processo.status
      }).then(async () => {
        //  TODO - Recuperar ação dinamicamente
        await this.tramitaComAcao(this.acao ? this.acao : 'FINALIZAR.DRF.OFICIO')
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'Ofício assinado com Sucesso.'
        )
      })
      this.closeModal()
      this.goToListagem()
    },

    atualizarAnexos (anexos) {
      this.anexos = anexos
    },

    changeInteiroTeor (inteiroTeor) {
      this.inteiroTeor = inteiroTeor
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .el-step.is-simple .el-step__title {
  font-size: 14px;
}

>>> .el-steps--simple {
  padding: 10px;
}

>>> .el-step.is-simple .el-step__icon {
  width: 12px;
  height: 12px;
}

.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
}
.right {
  align-items: right;
  text-align: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/oficio/EmissaoOficio.vue